import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Ui from './components/Ui';
import { BrowserRouter } from "react-router-dom";
import ReactGA from 'react-ga';
import { clarity } from "react-microsoft-clarity";
import { ENV, PROD_ENV, constants } from './constants/constants';
import authService from './services/auth.service';




















const App = () => {




  // TODO: Update TRACKING_ID to actual ID
  // Start Google Analytics Code
  const TRACKING_ID = "UA-XXXXX-X"; // OUR_TRACKING_ID
  if (ENV === PROD_ENV) ReactGA.initialize(TRACKING_ID);
  // End Google Analytics Code


  const MICROSOFT_CLARITY_ID = constants().MICROSOFT_CLARITY_ID;
  const isAuthenticated = authService.isAuthenticated();


  useEffect(() => {
    AOS.init({
      delay: 100,
    });
    AOS.refresh();
  }, []);



  // initialize Microsoft Clarity for analytics in prod and non-signed-in users
  if ((ENV === PROD_ENV) || (!isAuthenticated)) {
    clarity.init(MICROSOFT_CLARITY_ID);
  }



  useEffect(() => {
    AOS.init({
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Ui />
      </BrowserRouter>
    </>
  )
}
export default App;

